import React, { useContext, useEffect, useState } from "react";
import { Alert, Card, CardContent, CardHeader, Skeleton, Typography } from "@mui/material";
import { FaInfoCircle, FaTrashAlt } from "react-icons/fa";
import Heading from "../../core/Heading";
import CommentModal from "../modals/CommentModal";
import TextModal from "../modals/TextModal";
import DynamicCCListAddNewModal from "./DynamicCCListAddNewModal";
import { useDeleteCCDataMutation, useGetSingleCCDataQuery } from "modules/pvs_activities/redux/service/dForm";
import { FormDataContext } from "../../contexts/FormContext";
import { displayNotification } from "helpers";
import DropdownMenu from "../../DropdownMenu";
import _ from "lodash";

const DynamicListField = (props) => {
    const formDataContext = useContext(FormDataContext);

    const [data, setData] = useState([]);
    const dataRes = useGetSingleCCDataQuery(
        {
            formId: formDataContext.templateId,
            sectionId: formDataContext.sectionId,
            elementId: props.elementId,
            movementId: formDataContext.movementId,
            ccId: props.ccId,
            key: props.listKey,
        },
        { skip: formDataContext.mode === "preview" }
    );
    const [deleteEntry, deleteEntryRes] = useDeleteCCDataMutation();

    useEffect(() => {
        if (dataRes.isError) {
            displayNotification("error", `Error saving Critical Competency ${props.label} data.`);
            console.error({ error: dataRes.error });
        }
        if (dataRes.isSuccess) {
            setData([...dataRes.data]);
        }
    }, [dataRes]);

    useEffect(() => {
        if (deleteEntryRes.isError) {
            displayNotification("error", `Error delete Critical Competency ${props.label} data.`);
            console.error({ error: dataRes.error });
        }
        if (deleteEntryRes.isSuccess) {
            displayNotification("success", `Succesfully deleted Critical Competency ${props.label} entry.`);
        }
    }, [deleteEntryRes]);

    useEffect(() => {
        if (props.isFocused && formDataContext.mode === "data_entry") {
            dataRes.refetch();
        }
    }, [props.isFocused]);

    const handleOnChange = (val) => {
        setData([...data, val]);
    };

    const handleDelete = (id) => {
        if (!window.confirm("You are about to delete an entry. Are you sure?")) return;
        if (formDataContext.mode === "data_entry") {
            deleteEntry(id);
        } else {
            setData(data.filter((r) => String(r.id) !== String(id)));
            displayNotification("success", `Succesfully deleted Critical Competency ${props.label} entry.`);
        }
    };

    return (
        <>
            <div className="d-flex align-items-center mb-3">
                <Heading size="h6" font="Sohne-Buch" label={props.label} />
                <div className="ms-auto">
                    <DynamicCCListAddNewModal
                        elementId={props.elementId}
                        ccId={props.ccId}
                        type={props.label}
                        listKey={props.listKey}
                        className="me-2"
                        size="small"
                        onChange={handleOnChange}
                    />
                    <TextModal
                        title="Instructions"
                        icon={<FaInfoCircle />}
                        content={""}
                        className="me-2"
                        size="small"
                    />
                    <CommentModal elementId={props.elementId} ccId={props.ccId} />
                </div>
            </div>
            <div className="mb-2">
                {dataRes.isLoading ? (
                    <>
                        <Skeleton variant="rounded" width={"100%"} height={100} sx={{ mb: 1 }} />
                        <Skeleton variant="rounded" width={"100%"} height={100} sx={{ mb: 1 }} />
                    </>
                ) : data.length > 0 ? (
                    data.map((r, k) => (
                        <Card key={r.id} sx={{mb:1 }} className="bg-white">
                            <CardContent sx={{ px: 2, pb: 0, pt: 0 }}>
                                {/* {r.content} */}
                                {r.key_value_text && (
                                    <>
                                        <div className="text-primary">Key: {r.key_value_text}</div>
                                    </>
                                )}
                            </CardContent>
                            <CardHeader
                                sx={{ px: 2, py:1 }}
                                // title={`${_.capitalize(props.listKey)} ${k + 1}:`}
                                // subheader={r.created_date}
                                action={
                                    <DropdownMenu
                                        items={[
                                            {
                                                text: "Delete",
                                                icon: <FaTrashAlt />,
                                                onClick: () => handleDelete(r.id),
                                            },
                                        ]}
                                    />
                                }
                                title={
                                <Typography className="fs-5">
                                    <ul>
                                        {r.content?.split("\n").map((item, key) => {
                                            return <li key={key}>{item}</li>;
                                        })}
                                    </ul>
                                    {/* {r.content} */}
                                </Typography>}
                            />
                            
                        </Card>
                    ))
                ) : (
                    <Alert severity="info">No entries in this list</Alert>
                )}
            </div>
        </>
    );
};

DynamicListField.defaultProps = {
    elementId: "",
    ccId: "",
    type: "",
    listKey: "",
    label: "Label Here",
    value: [],
    onChange: () => {},
    disabled: false,
    isFocused: false,
};

export default DynamicListField;
